module.exports = __webpack_public_path__ + "static/media/7ICJ1.b304c0cf.jpg";